import axios from 'axios';

class AdminService {
  updateTimeSpent(data) {
    return axios.post('/admin/updateTime', data);
  }

  getTimeSpent() {
    return axios.get(`/admin/getTime`);
  }

  deleteUser(id) {
    return axios.delete(`/admin/deleteUser/${id}`);
  }

  restoreUser(id) {
    return axios.delete(`/admin/restoreUser/${id}`);
  }

  generateExcel() {
    return axios.get('/admin/generateExcel');
  }

  generateBackupExcel() {
    return axios.get('/admin/generateBackupExcel');
  }

  generateSecureCache() {
    return axios.get('/admin/generateSecureCache');
  }

  bulkCreateUniversities(data) {
    return axios.post('/admin/bulk-universities', data);
  }

  bulkCreateCourses(data) {
    return axios.post('/admin/bulk-courses', data);
  }

  bulkCreatePreviousStudents(data) {
    return axios.post('/prev-student/bulk-insert', data);
  }

  setStudentIntake() {
    return axios.post('/admin/setStudentIntake');
  }

  // CRUD intakes

  initialIntakes(data) {
    return axios.post('/admin/initialIntakes', data);
  }

  updateIntake(data) {
    return axios.post('/admin/updateIntake', data);
  }

  addNewIntake(data) {
    return axios.post('/admin/addNewIntake', data);
  }

  deleteIntake(id) {
    return axios.delete(`/admin/deleteIntake/${id}`);
  }

  // Time Spent

  getUserTimeSpent(id) {
    return axios.get(`/admin/getUserTimeSpent/${id}`);
  }

  getUserProfile(id) {
    return axios.get(`/admin/getUserProfile/${id}`);
  }
}

export default new AdminService();
